import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const brandGold = "#ffb700";

const Navbar = ({ setPage, activePage }) => {
  // State to manage mobile menu
  const [isOpen, setIsOpen] = useState(false);
  
  const navLinks = ['home', 'services', 'pricing', 'careers', 'contact'];

  // Helper to handle navigation and close menu automatically on mobile
  const handleNavClick = (link) => {
    setPage(link);
    setIsOpen(false); // Close the mobile menu when a link is clicked
  };

  return (
    <>
      <nav className="fixed w-full z-[100] bg-[#020408]/80 backdrop-blur-xl border-b border-white/5 px-4 md:px-12 py-4 flex justify-between items-center transition-all">
        {/* Brand Logo */}
        <div 
          className="text-2xl md:text-3xl font-extrabold tracking-tighter flex items-center select-none gap-[1px] cursor-pointer"
          onClick={() => handleNavClick('home')}
        >
          <span style={{ color: '#020408', WebkitTextStroke: `1px ${brandGold}`, fontWeight: 900 }}>Stark</span>
          <span className="font-black tracking-tighter" style={{ color: brandGold, fontWeight: 900 }}>xAi</span>
        </div>

        {/* Desktop Navigation Links */}
        <div className="hidden md:flex gap-10">
          {navLinks.map((link) => (
            <button
              key={link}
              onClick={() => setPage(link)}
              className={`text-xs font-bold uppercase tracking-[0.2em] transition-all hover:text-[#ffb700] ${
                activePage === link ? 'text-[#ffb700]' : 'text-slate-400'
              }`}
            >
              {link}
            </button>
          ))}
        </div>

        {/* Right Side Actions */}
        <div className="flex items-center gap-3 md:gap-4">
          <button 
            onClick={() => handleNavClick('contact')}
            className="bg-white text-black px-4 md:px-5 py-2 rounded-full text-[10px] md:text-xs font-black uppercase hover:bg-[#ffb700] hover:text-black transition-all"
          >
            Connect
          </button>
          
          {/* Mobile Hamburger Toggle */}
          <button 
            className="md:hidden text-white p-1 hover:text-[#ffb700] transition-colors"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle Menu"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[90] bg-[#020408]/95 backdrop-blur-2xl pt-28 px-6 flex flex-col items-center gap-8 md:hidden"
          >
            {navLinks.map((link, index) => (
              <motion.button
                key={link}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                onClick={() => handleNavClick(link)}
                className={`text-2xl font-black uppercase tracking-[0.2em] transition-all ${
                  activePage === link ? 'text-[#ffb700]' : 'text-slate-400'
                }`}
              >
                {link}
              </motion.button>
            ))}
            
            <motion.div 
              initial={{ opacity: 0 }} 
              animate={{ opacity: 1 }} 
              transition={{ delay: 0.5 }}
              className="mt-10 pt-10 border-t border-white/10 w-full text-center text-slate-500 text-[10px] uppercase tracking-widest font-bold"
            >
              Stark X Neural Core Network
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;